// extracted by mini-css-extract-plugin
module.exports = {"container":"support-link-dropdown_container__3XHN6"};